import { Grid } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import useUser from 'store/user/useUser';
import CollegePatientList from './CollegePatientList';

import PatientsList from './PatientsList';
import StudentList from './StudentList';
import ClassSectionList from './ClassSectionList';

const SearchToolbar = () => {
  const { student_uuid: user_id, isStudent, college_name } = useUser();

  return (
    <Grid
      container
      alignItems="center"
      spacing={1}
      sx={{ zIndex: zIndex.modal }}
    >
      {isStudent ? (
        <Grid item xs={10}>
          <PatientsList user_id={user_id} />
        </Grid>
      ) : (
        <>
          <Grid item xs={3.8}>
            <CollegePatientList user_id={user_id} />
          </Grid>
          <Grid item xs={3.8}>
            <ClassSectionList user_id={user_id} />
          </Grid>
          <Grid item xs={3.8}>
            <StudentList user_id={user_id} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SearchToolbar;
